import React, { useEffect, useState } from 'react';

const Question6 = ({ response, question, handleResponse }) => {

  const [selectedResponse, setSelectedResponse] = useState(response);

  const handleChange = (event) => {
    const value = event.target.value === 'true';
    setSelectedResponse(value);
    handleResponse(5, value);
  };

  const renderMessageBox = () => {
    if (selectedResponse === true) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <div className='message-content'>
            <p>Study Design Identified: <strong>{question.name}</strong></p>
            <br />
            <p>Requirements:</p>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <p dangerouslySetInnerHTML={{__html: question.message_html}}></p>
            </div>
          </div>
        </div>
      );
    } else if (selectedResponse === false) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <p>Uh oh! Something's not right. Based on your responses we cannot identify your study design. Please double check all previous responses.</p>
        </div>
      )
    }
    return null;
  };

  const renderProspectiveObservationalRadioButtons = () => {
    return (
      <div>
        <h5>{question.question_text}</h5>
        <input
          type="radio"
          name="educational"
          value="false"
          onChange={handleChange}
          checked={selectedResponse === false}
          id="educational_false"
        />
        <label htmlFor="educational_false">{question.false_response_text}</label>
        <br />
        <input
          type="radio"
          name="educational"
          value="true"
          onChange={handleChange}
          checked={selectedResponse === true}
          id="educational_true"
        />
        <label htmlFor="educational_true">{question.true_response_text}</label>
        <br />
        {renderMessageBox()}
      </div>
    );
  };

  return (
    <div>
      {renderProspectiveObservationalRadioButtons()}
    </div>
  );
};

export default Question6;